$('.TruyenThong .album-video').lightGallery({
	thumbnail:true,
	animateThumb: true,
	showThumbByDefault: true
}); 
